import angular from "angular";
import { directiveFactory } from "../angular-core";

export class ContextDirective implements ng.IDirective {
    static componentName: string = "context";

    restrict = "A";

    compile = (tElement: $TSFixMe, tAttrs: $TSFixMe, transclude: $TSFixMe) => {
        return {
            post: function postLink(scope: $TSFixMe, iElement: $TSFixMe, iAttrs: $TSFixMe, controller: $TSFixMe) {
                let ul = $("#" + iAttrs.context),
                    last: $TSFixMe = null;

                ul.css({
                    display: "none"
                });
                $(iElement).bind("contextmenu", function (event: $TSFixMe) {
                    event.preventDefault();
                    ul.css({
                        position: "fixed",
                        display: "block",
                        left: event.clientX + "px",
                        top: event.clientY + "px"
                    });
                    last = event.timeStamp;
                });

                $(document).click(function (event: $TSFixMe) {
                    const target = $(event.target);
                    if (!target.is(".popover") && !target.parents().is(".popover")) {
                        if (last === event.timeStamp) return;
                        ul.css({
                            display: "none"
                        });
                    }
                });
            }
        };
    };
}

angular.module("topline.directives", []).directive(ContextDirective.componentName, directiveFactory(ContextDirective));
